/** The slice of `navigator` the support probes read — injected so they test without a browser. */
export interface XRLike {
  isSessionSupported(mode: string): Promise<boolean>;
}

export interface NavigatorLike {
  xr?: XRLike;
  mediaDevices?: { getUserMedia?: unknown };
}

/** True only if WebXR `immersive-ar` is actually supported (false on iOS, where `xr` is absent). */
export async function isWebXRImmersiveArSupported(nav: NavigatorLike): Promise<boolean> {
  if (!nav.xr) return false;
  try {
    return await nav.xr.isSessionSupported("immersive-ar");
  } catch {
    return false;
  }
}

/** The gyro path's hard requirement is a camera; orientation sensors are universal where it exists. */
export function isGyroCameraSupported(nav: NavigatorLike): boolean {
  return typeof nav.mediaDevices?.getUserMedia === "function";
}

/** The slice of `document` the WebGL2 probe reads — injected so it tests without a browser. */
export interface DocumentLike {
  createElement(tag: "canvas"): { getContext(id: string): unknown };
}

/** The image-tracking detector runs on WebGL2 (TF.js-WebGL); a device without it can't run it. */
export function isWebGL2Supported(doc: DocumentLike): boolean {
  try {
    return Boolean(doc.createElement("canvas").getContext("webgl2"));
  } catch {
    return false;
  }
}
